import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ResponseInstrumentKV,
  InstrumentCreateRequest,
  InstrumentUpdateRequest,
  ResponseInstrument,
} from '../../domain/entities/InstrumentEntity';
import { instrumentKeys, instrumentRepository } from '../../infrastructure/InstrumentConstants';
import { ResponseInstrumentTypes } from '@/modules/dashboard/domain/entities/DashboardEntity';

export const useGetInstrument = () => {
  return useQuery<ResponseInstrumentKV, Error>({
    queryKey: instrumentKeys.all,
    queryFn: () => instrumentRepository.getAllInstruments(),
  });
}

export const useGetInstrumentById = (id: string) => {
  return useQuery<ResponseInstrumentKV, Error>({
    queryKey: instrumentKeys.details(id),
    queryFn: () => instrumentRepository.getInstrumentById(id),
    enabled: !!id,
  });
}

export const useCreateInstrument = () => {
  const queryClient = useQueryClient();

  return useMutation<ResponseInstrument, Error, InstrumentCreateRequest>({
    mutationFn: (instrument) => instrumentRepository.createInstrument(instrument),
    onSuccess: () => {

      queryClient.invalidateQueries({ queryKey: instrumentKeys.all });
    },
  });
}

export const useUpdateInstrument = () => {
  const queryClient = useQueryClient();

  return useMutation<ResponseInstrument, Error, InstrumentUpdateRequest>({
    mutationFn: (instrument) => instrumentRepository.updateInstrument(instrument),
    onSuccess: (_, variables) => {

      queryClient.invalidateQueries({ queryKey: instrumentKeys.all });
      if (variables.id) {
        queryClient.invalidateQueries({ queryKey: instrumentKeys.details(variables.id) });
      }
    },
  });
}

export const useDeleteInstrument = () => {
  const queryClient = useQueryClient();

  return useMutation<ResponseInstrument, Error, string>({
    mutationFn: (id) => instrumentRepository.deleteInstrument(id),
    onSuccess: (_, id) => {

      queryClient.invalidateQueries({ queryKey: instrumentKeys.all });

      queryClient.removeQueries({ queryKey: instrumentKeys.details(id) });
    },
  });
}

export const useGetInstrumentTypes = () => {
  return useQuery<ResponseInstrumentTypes, Error>({
    queryKey: instrumentKeys.allInstrumentTypes,
    queryFn: () => instrumentRepository.getAllInstrumentTypes(),
  });
}